import LocalizedStrings from "react-localization";

export const updateCreativeStrings = new LocalizedStrings({
  en: {
    description: "Description",
    preview: "Preview",
    detail: "Detail",
    prevButton: "Prev",
    nextButton: "Next",
    paperClipLabel: "Enter Paper Clip label",
    paperClip: "Paper clip",
    reject: "Reject",
    validate: "Validate",
    changeAll: "Change All",
  },
  fr: {
    description: "Description",
    preview: "Aperçu",
    detail: "Détail",
    prevButton: "Préc",
    nextButton: "Suiv",
    paperClipLabel: "L'étiquette du Trombone",
    paperClip: "Trombone",
    reject: "Rejeter",
    validate: "Valider",
    changeAll: "Tout Changer",
  },
});
